import { jsx as c } from "react/jsx-runtime";
import p, { useMemo as f, useState as h, useContext as u } from "react";
import v from "../../utils/authManager.js";
import { S as e } from "../../errors-YTprc4A2.mjs";
const i = p.createContext({}), d = ({
  client_id: o,
  loginUrl: n,
  linkTarget: m,
  redirect_uri: t,
  post_logout_redirect_uri: g,
  authStore: r = sessionStorage,
  children: w
}) => {
  if (!o)
    throw new e("LoginContext error: missing param 'client_id'");
  if (!n)
    throw new e("LoginContext error: missing param 'loginUrl'");
  if (!t)
    throw new e("LoginContext error: missing param 'redirect_uri'");
  const s = f(() => new v(n, o, t, g, r), [n, o, t, g, r]), L = s.getUserInfo(), [a, x] = h(() => !!L), C = f(
    () => ({
      setIsLoggedIn: x,
      loginUrl: n,
      client_id: o,
      linkTarget: m,
      authManager: s,
      redirect_uri: t,
      authStore: r,
      isLoggedIn: a
    }),
    [
      a,
      r,
      s,
      m,
      o,
      t,
      x,
      n
    ]
  );
  return /* @__PURE__ */ c(i.Provider, { value: C, children: w });
};
function j() {
  const o = u(i);
  if (!o)
    throw new e("LoginContext must be used with LoginProvider!");
  return o;
}
function A() {
  const o = u(i);
  if (!o)
    throw new e("LoginContext must be used with LoginProvider!");
  return o;
}
export {
  d as LoginProvider,
  j as useLoginConsumerContext,
  A as useLoginContext
};
